import { LobbyImage } from '@colonist/types';
import { createDivIn, createImgIn, createLinkIn, createParagraphIn } from '../../../../shared/scripts/ui_utils/DomUtils.ts';
export class UIMFullscreenHeader {
    constructor(container, title, isBackButtonX = false){
        this.container = createDivIn(container, 'fullscreen-header');
        this.backButton = createLinkIn(this.container, '', {
            key: 'strings:colonistCommon.utils.emptyString'
        }, 'fullscreen-header-back-link');
        this.backButton.removeAttribute('href');
        createImgIn(this.backButton, isBackButtonX ? LobbyImage.XMark : LobbyImage.LeftArrow);
        this.title = createParagraphIn(this.container, title, 'fullscreen-header-title');
    }
}
